import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actions, { withProductLine } from '../../actions/GenericBenefitsSets'
import { createFlashMessage } from '../../actions/FlashMessages'
import BenefitsSetEdit from '../BenefitsSet/BenefitsSetEdit'
import CriticalIllnessBenefitsSetForm from './CriticalIllnessBenefitsSetForm'
import issuerActions from '../../actions/Issuers'
import historyActions from '../../actions/BenefitsSetFieldHistories'
import howieServiceAreaActions from '../../actions/HowieServiceAreas'
import platformActions from '../../actions/Platforms'

const mapStateToProps = (state) => {
  const slice = state.genericBenefitsSets.update
  const showSlice = state.genericBenefitsSets.show
  const remoteOptionsSelectStates = {
    issuers: state.issuers.index,
    howie_service_areas: state.howieServiceAreas.index,
    privileged_platforms: state.platforms.index
  }
  const configuration = state.login.session.configuration.generic_benefits

  const historySlice = state.benefitsSetFieldHistory.index

  return {
    generalError: slice.generalError,
    resourceErrors: slice.resourceErrors,
    attributes: showSlice.attributes,
    id: slice.id,
    updated: slice.updated,
    requestComplete: slice.requestComplete,
    configuration,
    remoteOptionsSelectStates,
    benefitsSetFieldHistory: historySlice.records,
    benefitsSetForm: CriticalIllnessBenefitsSetForm,
    benefitsSetUrl: 'critical_illness_benefits',
    productLine: 'Critical Illness'
  }
}

const mapDispatchToProps = (dispatch) => ({
  update: bindActionCreators(withProductLine('critical_illness', actions.update.main), dispatch),
  show: bindActionCreators(withProductLine('critical_illness', actions.show.main), dispatch),
  reset: bindActionCreators(actions.update.reset, dispatch),
  showReset: bindActionCreators(actions.show.reset, dispatch),
  history: bindActionCreators(historyActions.index.main, dispatch),
  resetHistory: bindActionCreators(historyActions.index.reset, dispatch),

  remoteOptionsSelectActions: {
    howieServiceAreasIndex: {
      main: bindActionCreators(howieServiceAreaActions.index.main, dispatch),
      reset: bindActionCreators(howieServiceAreaActions.index.reset, dispatch)
    },
    issuersIndex: {
      main: bindActionCreators(issuerActions.index.main, dispatch),
      reset: bindActionCreators(issuerActions.index.reset, dispatch)
    },
    platformsIndex: {
      main: bindActionCreators(platformActions.index.main, dispatch),
      reset: bindActionCreators(platformActions.index.reset, dispatch)
    }
  },

  createFlashMessage
})

export default connect(mapStateToProps, mapDispatchToProps)(BenefitsSetEdit)
